import { get, post } from '../../../../api/axios';
import { SetupEndpoints } from '../../../../api/endpoints/SetupEndpoints';
import { type CompanyDto } from '../../../models/CompanyDto';
import { type SetupRequestDto } from '../../../models/SetupRequestDto';
import { type AttachmentDto } from '../../../models/AttachmentDto';
import type { AxiosProgressEvent } from 'axios';

export const setupCompany = (setupData: SetupRequestDto) => {
  return post(SetupEndpoints.setup, setupData);
};

export const setupLogo = (image: File, onUploadProgress: (progressEvent: AxiosProgressEvent) => void) => {
  const formData = new FormData();
  formData.append('file', image);
  return post<AttachmentDto>(SetupEndpoints.setLogo, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const getSetupDetails = () => {
  return get<CompanyDto>(SetupEndpoints.setup);
};
